import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { BlocSettingsForm } from "./";

import * as dataActions from "../../../../../../utils/data/dataActions";
import { BLOCS, INSURERS } from "../../../../../../utils/data/models";

class BlocSettingsPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      response: {},
      showConfirmationModal: false,
      confirmationMessage: "",
      confirmationActions: [],
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillMount() {
    this.props.dataActions.getDataList(
      INSURERS,
      0,
      0,
      "",
      ["localizations.name:asc"],
      [INSURERS.archiveFilter],
      {},
      {},
      "insurerId,localizations.name"
    );
  }

  formatDataForForm() {
    const { bloc = {} } = this.props;
    const {
      acombaInsurers: insurers = [],
      acombaTaxes: taxes = [],
      ...ledgers
    } = bloc;

    let acombaInsurers = {};
    insurers.map((i) => {
      acombaInsurers[i.insurerId] = i.acombaNumber;
    });

    let acombaTaxes = {};
    taxes.map((t) => {
      acombaTaxes[t.provinceCode] = t.acombaNumber;
    });

    return { acombaInsurers, acombaTaxes, ...ledgers };
  }

  formatDataForSubmit(data) {
    const {
      bloc: { blocId },
    } = this.props;
    const { acombaInsurers: insurers, acombaTaxes: taxes, ...ledgers } = data;

    let acombaInsurers = [];
    for (let insurerId in insurers) {
      // skip loop if the property is from prototype
      if (!insurers.hasOwnProperty(insurerId)) continue;
      acombaInsurers.push({
        acombaNumber: insurers[insurerId],
        blocId,
        insurerId,
      });
    }

    let acombaTaxes = [];
    for (let provinceCode in taxes) {
      // skip loop if the property is from prototype
      if (!taxes.hasOwnProperty(provinceCode)) continue;
      acombaTaxes.push({
        acombaNumber: taxes[provinceCode],
        blocId,
        provinceCode,
      });
    }

    return { acombaInsurers, acombaTaxes, ...ledgers };
  }

  onSubmit(values) {
    const { dataActions } = this.props;
    const data = this.formatDataForSubmit(values);

    dataActions.updateDataItem(BLOCS, data).then(() => {
      this.context.getData();
    });
  }

  render() {
    const { authLanguageCode, allLoaded } = this.props;
    const initialValues = this.formatDataForForm();

    return (
      <div className="sub-content">
        <BlocSettingsForm
          authLanguageCode={authLanguageCode}
          initialValues={initialValues}
          insurers={this.props.insurers}
          loaded={allLoaded}
          onSubmit={this.onSubmit}
        />
      </div>
    );
  }
}

BlocSettingsPage.propTypes = {
  bloc: PropTypes.object,
  allLoaded: PropTypes.bool,
  authLanguageCode: PropTypes.string,
  dataActions: PropTypes.object,
  insurers: PropTypes.array,
};

BlocSettingsPage.contextTypes = {
  getData: PropTypes.func,
};

function mapStateToProps(state) {
  const blocs = state.data.blocs || {};
  const bloc = blocs.active || {};
  const insurers = state.data.insurers || {};

  return {
    bloc,
    allLoaded: !!insurers.fetched && !!blocs.itemFetched,
    authLanguageCode: state.auth.user.languageCode,
    insurers: insurers.items || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BlocSettingsPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/blocs/bloc/settings/BlocSettingsPage.js